// UI-30: Guide/Driver user roles are irrelevant to the scope of Zero Stars Hotels.
// Filter them out of the available-person-roles API response so every role dropdown
// (Extranet user form, etc.) omits them. zsh-only (customization layer plugin).
//
// Registered in customization_layers/zsh/nuxt.config.ts (the layer's plugins/ dir is not
// auto-discovered). Deferred to the `app:created` hook because this plugin runs before the
// core 030.axios plugin that provides $axios.
// Role values are prefixed by company type (e.g. supp.guide, to1l.driver); drop any whose
// suffix is guide/driver regardless of the prefix.
export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.hook('app:created', () => {
        const $axios = (nuxtApp as any).$axios
        if (!$axios || typeof $axios.onResponse !== 'function') return

        $axios.onResponse((response: any) => {
            const data = response && response.data
            if (data && Array.isArray(data.availableRoleGroups)) {
                data.availableRoleGroups = data.availableRoleGroups.filter((role: any) => {
                    const suffix = String(role?.value ?? '').split('.').pop()?.toLowerCase()
                    return suffix !== 'guide' && suffix !== 'driver'
                })
            }
            return response
        })
    })
})
